import { render, staticRenderFns } from "./index_item.vue?vue&type=template&id=0204e19f&scoped=true&"
import script from "./index_item.vue?vue&type=script&lang=js&"
export * from "./index_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204e19f",
  null
  
)

export default component.exports